import {
  DocumentTagV2,
  SourceSystemV2,
} from "@hagerty/customer-insurance-gateway-client";
import { Country } from "shared";

const { origin } = window.location;
const prefix = process.env.REACT_APP_BASE_PATH ?? "";
const apBaseUrl = `${origin}${prefix}`;

export const routes = {
  go: (route: string) => window.location.assign(route),
  main: apBaseUrl,
  policyDetails: (id: string) => `${apBaseUrl}/policy/${id}`,
  policyPaymentMethod: (policyNumber: string) =>
    `${origin}/policy/${policyNumber}/payment-method`,
  settings: (success?: boolean) =>
    `${apBaseUrl}/settings${success ? "?success=true" : ""}`,
  editName: `${apBaseUrl}/settings/name`,
  editMailingAddress: `${apBaseUrl}/settings/address`,
  editPhoneNumber: `${apBaseUrl}/settings/phone`,
  documentDelivery: `${apBaseUrl}/settings/document-delivery`,
  membershipCard: `${apBaseUrl}/membership-card`,
  logout: (logoutId: string) => `${apBaseUrl}/logout/${logoutId}`,
  updatePaymentMethod: (policyNumber: string) =>
    `${apBaseUrl}/settings/update-payment-method/${policyNumber}`,
};

export const apiRoutes = {
  billing: `${apBaseUrl}/api/billing`,
  customer: `${apBaseUrl}/api/customer`,
  eSign: `${apBaseUrl}/api/e-sign`,
  membership: `${apBaseUrl}/api/hdc`,
  paperless: `${apBaseUrl}/api/paperless`,
  paymentIntent: `${apBaseUrl}/api/payment-intent`,
  policies: `${apBaseUrl}/api/policies/details`,
  policiesSummary: `${apBaseUrl}/api/policies/summary`,
  policy: (policyNumber: string) => `${apBaseUrl}/api/policy/${policyNumber}`,
  idCardUrl: (country: Country, policyNumber: string) =>
    `${apBaseUrl}/api/id-card-url/${country}/${policyNumber}`,
  documentUrl: (
    source: SourceSystemV2,
    document: DocumentTagV2,
    policyNumber: string
  ) => `${apBaseUrl}/api/document-url/${source}/${document}/${policyNumber}`,
};
